import { TermsOfService } from '../../../pairing/tos/tos.component';
import { AudioPlayer } from '../../../audio/audio.component';

export const routes = [
  {
    path: 'audio/:audioId',
    component: AudioPlayer,
    widgets: ['CookieConsent', 'SnackBar', 'Popup'],
    options: {
      preventStorage: true,
      reuseInstance: false,
    },
  },
  {
    path: 'radio/:audioId',
    component: AudioPlayer,
    widgets: ['CookieConsent', 'SnackBar', 'Popup'],
    options: {
      preventStorage: true,
      reuseInstance: false,
    },
  },
  {
    path: 'ssi',
    component: TermsOfService,
    widgets: ['CookieConsent', 'Popup'],
  },
];
